<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col cols="12" sm="6" :lg="blockwidth" v-if="hideorgblock">
        <b-card :no-body="true" footer-class="px-3 py-2">
          <b-card-body class="p-3 clearfix">
            <i class="fa fa-sitemap bg-primary p-3 font-2xl mr-3 float-left"></i>
            <div class="h5 text-primary mb-0 mt-2"> {{ form.orgtotal}}</div>
            <div class="text-muted  font-weight-bold font-xs">Organizations</div>
          </b-card-body>
          <div slot="footer">
            <b-link v-b-tooltip.hover class="font-weight-bold font-xs btn-block text-muted" title="View More Organizations" href="#/org/list">View More <i class="fa fa-angle-right float-right font-lg"></i></b-link>
          </div>
        </b-card>
      </b-col>
      <b-col cols="12" sm="6" :lg="blockwidth" v-if="hideuserblock">
        <b-card :no-body="true" footer-class="px-3 py-2">
          <b-card-body class="p-3 clearfix">
            <i class="fa fa-users bg-primary p-3 font-2xl mr-3 float-left"></i>
            <div class="h5 text-primary mb-0 mt-2"> {{ form.usertotal}}</div>
            <div class="text-muted  font-weight-bold font-xs">Users</div>
          </b-card-body>
          <div slot="footer">
            <b-link v-b-tooltip.hover class="font-weight-bold font-xs btn-block text-muted" title="View More Users" href="#/user/list">View More <i class="fa fa-angle-right float-right font-lg"></i></b-link>
          </div>
        </b-card>
      </b-col>
      <b-col cols="12" sm="6" :lg="blockwidth" v-if="hiderolblock">
        <b-card :no-body="true" footer-class="px-3 py-2">
          <b-card-body class="p-3 clearfix">
            <i class="fa fa-cogs bg-primary p-3 font-2xl mr-3 float-left"></i>
            <div class="h5 text-primary mb-0 mt-2"> {{ form.roletotal}}</div>
            <div class="text-muted  font-weight-bold font-xs">Roles</div>
          </b-card-body>
          <div slot="footer">
            <b-link v-b-tooltip.hover class="font-weight-bold font-xs btn-block text-muted" title="View More Roles" href="#/role/list">View More <i class="fa fa-angle-right float-right font-lg"></i></b-link>
          </div>
        </b-card>
      </b-col>
      <b-col cols="12" sm="6" :lg="blockwidth">
        <b-card :no-body="true" footer-class="px-3 py-2">
          <b-card-body class="p-3 clearfix">
            <i class="fa fa-houzz bg-primary p-3 font-2xl mr-3 float-left"></i>
            <div class="h5 text-primary mb-0 mt-2"> {{ form.invtotal}}</div>
            <div class="text-muted  font-weight-bold font-xs">Inventories</div>
          </b-card-body>
          <div slot="footer">
            <b-link v-b-tooltip.hover class="font-weight-bold font-xs btn-block text-muted" title="View More Inventories" href="#/inventory/list">View More <i class="fa fa-angle-right float-right font-lg"></i></b-link>
          </div>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import { getResponseMessages, getUserInfo } from '../_helpers'
export default {
  name: 'dashboard',
  data() {
    return {
      blockwidth:0,
      hideorgblock:false,
      hiderolblock:false,
      hideuserblock:false,
      form: {
        orgtotal:0,
        usertotal:0,
        roletotal:0,
        invtotal:0
      }
    }
  },
  created(){
    const user = getUserInfo();
    if(user.roleid == 1){
      this.hideorgblock = true
      this.hideuserblock = true
      this.hiderolblock = true
      this.blockwidth = 3
    }
    if(user.roleid == 2){
      this.hideorgblock = true
      this.hideuserblock = true
      this.blockwidth = 4
    }
    if(user.roleid == 3){
      this.hideuserblock = true
      this.blockwidth = 6
    }
    if(user.roleid == 4){
      this.blockwidth = 4
    }
    this.$eventHub.on('reloadDashBoard',()=>{
      this.loadDashBoardData();
    });
    setTimeout(()=> {
      this.loadDashBoardData()
    }, 500)
  },
  methods: {
    ...mapActions('org', ['getById']),
    loadDashBoardData() {
      this.$store.dispatch('getById', {url:'organization/loadDashBoardData',data :{}}).then((res) => {
        this.form = Object.assign({}, res)
      },(error) =>{
        this.$toastr('error', getResponseMessages(error.data.messages), 'Error')
      });
    },
  }  
}
</script>
